module.exports = "/fonts/vendor/devextreme/dist/css/icons/dxicons.woff?25bc68a9f22a08322fa5950bd3950db0";